import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { GoogleG } from "./Reviews";

export default function HeroGoogleRating() {
  const [g, setG] = useState(null);
  useEffect(() => {
    api.get("/reviews/google").then((r) => setG(r.data)).catch(() => {});
  }, []);
  if (!g) return null;
  const link = g.url ? { href: g.url, target: "_blank", rel: "noopener noreferrer" } : { href: "#reviews" };
  return (
    <a {...link} className="inline-flex items-center gap-3 rounded-full bg-white/85 backdrop-blur-md border border-[#171715]/[0.07] pl-2.5 pr-4 py-2 shadow-[0_14px_30px_-24px_rgba(23,23,21,.5)] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-white fade-up" style={{ animationDelay: ".24s" }} data-testid="hero-google-rating">
      <GoogleG className="w-6 h-6 shrink-0" />
      <span className="font-display text-lg font-bold leading-none" data-testid="hero-google-rating-value">{g.rating.toFixed(1)}</span>
      <span className="relative inline-flex text-[#E3DCCF]">
        {Array.from({ length: 5 }, (_, i) => <Star key={i} size={14} fill="currentColor" />)}
        <span className="absolute inset-0 flex overflow-hidden text-[#F4B400]" style={{ width: `${(g.rating / 5) * 100}%` }}>
          {Array.from({ length: 5 }, (_, i) => <Star key={i} size={14} fill="currentColor" className="shrink-0" />)}
        </span>
      </span>
      <span className="text-xs text-[#77736B] whitespace-nowrap" data-testid="hero-google-rating-count">{g.count} Google rəyi</span>
    </a>
  );
}
